import React, { useState } from "react";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { makeStyles } from "@material-ui/styles";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PermissionCheck from "../../../Component/PermissionCheck";
import CustomPopover from "./Component/CustomPopover";
import { resetReducer } from "../../../store/reducers/digitalmarketing/customer";
import Customer from "../Customer";
import CustomerDetails from "../Customer/CustomerDetails";
import { useAddBulkCustomerMutation } from "../../../Service/customers";
import FileUploadModal from "../../../Component/DigitalMarketing/FileUploadModal";

const useStyles = makeStyles({
  menu: {
    "& .MuiPaper-elevation": {
      borderRadius: "10px",
    },
  },
});

function DashTabs(props) {
  const { onFilter, handleOpen, setShowAddType, showAddType } = props;
  const classes = useStyles();
  const [activeId, setActiveId] = useState<any>(7);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorEl1, setAnchorEl1] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const DashboardStatus = useSelector((state: any) => state.dashboard.status);
  const dispatch = useDispatch<any>();
  const account = useSelector((state: any) => state.auth);
  const { roleName } = account;
  const values = [...DashboardStatus, { id: 7, name: "All" }];

  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [selectedLeadType, setSelectedLeadType] = useState<string>("");

  const [uploadBulkCustomer, { isLoading }] = useAddBulkCustomerMutation(); // API Mutation Hook

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handlePopoverOpen1 = (
    event: React.MouseEvent<HTMLElement>,
    type: string
  ) => {
    setAnchorEl(null);
    setAnchorEl1(event.currentTarget);
    setShowAddType(type);
  };

  const handlePopoverClose1 = () => {
    setAnchorEl1(null);
  };

  const open = Boolean(anchorEl);
  const open1 = Boolean(anchorEl1);

  // Handles opening the File Upload modal
  const handleOpenUploadModal = (leadType: string) => {
    setSelectedLeadType(leadType);
    setUploadModalOpen(true);
    setAnchorEl1(null); // Close popover
    setUploadModalOpen(true); // Open modal
  };

  // Handle file upload API call
  const handleUpload = async (file: File) => {
    if (!file) {
      alert("Please select a file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append(
      "ivf_journey_status",
      selectedLeadType === "fertility" ? "1" : "0"
    );

    try {
      await uploadBulkCustomer(formData).unwrap();
      setUploadModalOpen(false); // Close the modal after upload
      setShowAddType(""); // Reset state after upload
    } finally {
      setUploadModalOpen(false);
    }
  };

  const options = [
    {
      label: "General Lead",
      onClick: (event) => handlePopoverOpen1(event, "general"),
    },
    {
      label: "Fertility Lead",
      onClick: (event) => handlePopoverOpen1(event, "fertility"),
    },
  ];

  const options1 = [
    {
      label: "Add Manually",
      onClick: () => {
        dispatch(resetReducer());
        navigate(`/customer/${showAddType}`);
      },
    },
    {
      label: "Upload File",
      onClick: () => handleOpenUploadModal(showAddType),
    },
  ];

  return (
    <div className="Dash-table mt-4">
      {/* <ul>
        {values.map((val, i) => (
          <li
            onClick={() => {
              setActiveId(val.id);
              onFilter(val.name);
            }}
            key={i}
            className={activeId === val.id ? "acti" : ""}
          >
            {val.name}
          </li>
        ))}
      </ul> */}
      {(roleName === "branch" || roleName === "receptionist") && (
        <div className="d-flex justify-content-end mb-2">
          <>
            {/* <Button variant="contained" id="btn-add" onClick={handleOpen}>
        + Bulk upload
      </Button> */}

            <Button variant="contained" id="btn" onClick={handlePopoverOpen}>
              + Add leads
            </Button>

            <CustomPopover
              open={open}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              transformOrigin={{ vertical: "bottom", horizontal: "center" }}
              options={options}
            />
            <CustomPopover
              open={open1}
              anchorEl={anchorEl1}
              onClose={handlePopoverClose1}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              transformOrigin={{ vertical: "bottom", horizontal: "center" }}
              options={options1}
            />
            <FileUploadModal
              open={uploadModalOpen}
              handleClose={() => setUploadModalOpen(false)}
              handleUpload={handleUpload}
              leadType={selectedLeadType} // Pass lead type dynamically
            />
          </>
        </div>
      )}
    </div>
  );
}

export default React.memo(DashTabs);
